import { SxProps, Theme } from '@mui/material';

export const styles: Record<'container' | 'buttonRow', SxProps<Theme>> = {
  buttonRow: {
    '&:hover': {
      background: (theme) => theme.palette.gray[200],
      cursor: 'pointer',
    },
    '.MuiBox-root + &': {
      '&::before': {
        backgroundColor: (theme) => theme.palette.gray[200],
        content: '""',
        height: '1px',
        left: (theme) => theme.spacing(2),
        position: 'absolute',
        right: 0,
        top: 0,
      },
    },
    alignItems: 'center',
    backgroundColor: (theme) => theme.palette.gray[50],
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'row',
    padding: (theme) => theme.spacing(2),
    position: 'relative',
  },
  container: {
    backgroundColor: (theme) => theme.palette.gray[50],
    borderRadius: '10px',
    overflow: 'hidden',
  },
};
